import { create } from 'zustand';

/**
 * État d'ouverture de l'assistant IA (chat), partagé entre le FAB `ChatFab`
 * (mobile) et le bouton IA de la pilule flottante `FloatingTopActions` (desktop).
 *
 * `ChatFab` détenait cet état en local ; on le remonte ici pour que plusieurs
 * déclencheurs puissent ouvrir le même `ChatPanel`.
 */
interface ChatUiState {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

export const useChatUiStore = create<ChatUiState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  toggle: () => set((state) => ({ open: !state.open })),
}));
